export default __webpack_public_path__ + "static/media/kenya.c71abb26.png";